import { RootState } from 'store';

import { STATE, IState } from '../types/state';

const selector = (state: RootState): IState['selectedPlace'] => {
  const { selectedPlace } = state[STATE];
  return selectedPlace;
};

export default selector;